
const AboutPage = () => {
  return (
    <div className="min-h-screen" style={{
      backgroundImage: 'url(/lovable-uploads/41c8c2b3-d68b-493f-85aa-dbe1c5dee707.png)',
      backgroundSize: '100% auto',
      backgroundPosition: 'top center',
      backgroundRepeat: 'no-repeat',
      backgroundColor: '#000',
      backgroundAttachment: 'scroll'
    }}>
      <div className="bg-slate-900/80 text-white py-16 backdrop-blur-sm">
        <div className="container-custom">
          <h1 className="text-4xl md:text-5xl font-bold text-white drop-shadow-lg">About Ọmọ Odùduwà</h1>
          <p className="text-xl mt-4 text-slate-200 drop-shadow-md">
            Who we are and what drives our commitment to the Yoruba people
          </p>
        </div>
      </div>

      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div className="p-6 rounded-lg backdrop-blur-sm bg-slate-800/90 border border-slate-700">
            <h2 className="section-title text-white drop-shadow-lg mb-6">Who We Are</h2>
            <p className="mb-4 text-slate-200 drop-shadow-sm">
              The Ọmọ Odùduwà is a civic organization dedicated to promoting 
              the welfare and advancement of the Yoruba people in Nigeria and across the diaspora.
            </p>
            <p className="mb-4 text-slate-200 drop-shadow-sm">
              Founded in 2020 by a coalition of professionals, community leaders, and cultural advocates, 
              Ọmọ Odùduwà works to address challenges facing Yoruba communities while celebrating and preserving 
              our rich cultural heritage.
            </p>
            <p className="text-slate-200 drop-shadow-sm">
              Our members come from diverse backgrounds but share a common commitment to progress, 
              unity, and the development of Yoruba communities.
            </p>
          </div>
          <div className="rounded-lg overflow-hidden shadow-xl">
            
          </div>
        </div>

        <div className="mt-16">
          <h2 className="section-title text-white drop-shadow-lg">What We Do</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-8">
            <div className="p-6 rounded-lg backdrop-blur-sm bg-slate-800/90 border border-slate-700">
              <h3 className="text-xl font-bold mb-3 text-white drop-shadow-md">Advocacy</h3>
              <p className="text-base text-slate-200 drop-shadow-sm">
                We advocate for policies that promote fairness, equity, and development in Yoruba 
                regions, engaging with government at all levels to ensure our voices are heard.
              </p>
            </div>
            <div className="p-6 rounded-lg backdrop-blur-sm bg-slate-800/90 border border-slate-700">
              <h3 className="text-xl font-bold mb-3 text-white drop-shadow-md">Education</h3>
              <p className="text-slate-200 drop-shadow-sm">
                We provide civic education, leadership training, and cultural awareness programs 
                designed to empower community members with knowledge and skills.
              </p>
            </div>
            <div className="p-6 rounded-lg backdrop-blur-sm bg-slate-800/90 border border-slate-700">
              <h3 className="text-xl font-bold mb-3 text-white drop-shadow-md">Community Building</h3>
              <p className="text-slate-200 drop-shadow-sm">
                We organize events, forums, and initiatives that strengthen community bonds, 
                promote dialogue, and foster collaboration among Yoruba people.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-16">
          <h2 className="section-title text-white drop-shadow-lg">Our Commitment</h2>
          <div className="p-8 border rounded-lg backdrop-blur-sm bg-slate-800/90 border-slate-700">
            <p className="italic text-lg mb-4 text-slate-200 drop-shadow-sm">
              "We are committed to honoring our past while building a progressive future that 
              ensures dignity, prosperity, and opportunity for all Yoruba people."
            </p>
            <p className="font-semibold text-right text-amber-400 drop-shadow-sm">- Ọmọ Odùduwà Founding Charter</p>
          </div>
          
          <div className="mt-8 p-6 rounded-lg backdrop-blur-sm bg-slate-800/90 border border-slate-700">
            <p className="mb-4 text-slate-200 drop-shadow-sm">
              The Ọmọ Odùduwà is guided by principles of transparency, inclusivity, 
              and accountability. We welcome all who share our vision for a vibrant, thriving 
              Yoruba community at home and abroad.
            </p>
            <p className="text-slate-200 drop-shadow-sm">
              Through partnership, innovation, and dedicated service, we work tirelessly to address 
              the challenges facing our communities while celebrating our achievements and preserving 
              our heritage for future generations.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
